import React, { useState, useEffect } from 'react';
import NewProduct from './NewProduct';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import ybLogo from '../../images/whats-new/yb-logo.jpg';

import './whats-new.scss';

const WhatsNew = props => {
   
   const [books, setBooks] = useState([]);
   const [prods, setProds] = useState([]);

   useEffect(() => {
      if (props.products && props.books && prods.length === 0 && books.length === 0) {
         setBooks(Object.values(props.books));
         setProds(Object.values(props.products));
      }
   }, [props.products, prods.length, props.books, books.length]);

   let newest = prods.filter(prod => {
      if (prod.group && prod.group === '2020') return prod;
      return null;
   });
   newest = newest.map(val => val.ipNumber);
   newest = books.filter(book => newest.includes(book.ipNumber))
   

   let ungrouped = prods.filter(prod => {
      if(!prod.group) return prod;
      return null;
   });
   ungrouped = ungrouped.map(val => val.ipNumber);
   ungrouped = books.filter(book => ungrouped.includes(book.ipNumber));


   let paideia = prods.filter(prod => {
      if (prod.group && prod.group === 'Paideia') return prod;
      return null;
   });
   paideia = paideia.map(val => val.ipNumber);
   paideia = books.filter(book => paideia.includes(book.ipNumber))

   
   let yb = prods.filter(prod => {
      if (prod.group && prod.group === 'yb') return prod;
      return null;
   });
   yb = yb.map(val => val.ipNumber);
   yb = books.filter(book => yb.includes(book.ipNumber));

   
   let wylie = prods.filter(prod => {
      if (prod.group && prod.group === 'Wylie’s History of Protestantism') return prod;
      return null;
   });
   wylie = wylie.map(val => val.ipNumber);
   wylie = books.filter(book => wylie.includes(book.ipNumber));

   return (
      <main className="container-flex">
         <Helmet>
            <title>Inheritance Publications : Latest christian books released</title>
            <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
            <meta name="description" content="This is our latest publications. All about reformed historical fiction, fiction & theology. Books suitable for the youngest children to the oldest. The best reformed books and media you will find here."/>
         </Helmet>
         <div className="about-us-heading wn-heading">
            <div className="about-us-shadow wn-shadow">
               <h1>What's New</h1>
            </div>
         </div>
         <div className="wn-content container">
            <div className="wn-content-intro">
               <p>Here you are able to check our latest published works.</p>
               <p>Some of them are part of series of books. To go directly to the series you can click one of them below...</p>

               <div>
                  <a href="#paideia-pre">The old Paideia Books of Piet Prins and others</a><p></p>
               </div>
               <div>
                  <a href="#yb-pre">Young Burning Hearts Series</a><p></p>
               </div>

               <div>
                  <a href="#wylie-pre">Wylie’s History of Protestantism</a><p></p>
               </div>
            </div>

            <div id="wn-2020" className="wn-series">
               <h2>2020 Publications</h2>
               {prods.length === 0 ?
                  <div className="p-5 d-flex justify-content-center align-items-center">
                     <ReactLoading type="spin" color="#2D3142" />
                  </div> :
                  newest.map((newer, i) => {
                     return (
                        <div key={newer.ipNumber}>
                           <NewProduct
                              product={newer}
                              isLast={i + 1 === newer.length ? false : true}
                              updateCartStorage={props.updateCartStorage}
                           />
                        </div>
                     )
                  })
               }
            </div>
            <div id="paideia-pre" className="p-5"></div>
            <div id="paideia" className="wn-series">
               <h2>New Books and Re-Publication of old Paideia Books of Piet Prins and others</h2>
            {prods.length === 0 ?
               <div className="p-5 d-flex justify-content-center align-items-center">
                  <ReactLoading type="spin" color="#2D3142" />
               </div>
               : ungrouped.map((prod, i) => {
                  return (
                     <div key={prod.ipNumber} className="">
                        <NewProduct 
                           product={prod}
                           isLast={i + 1 === ungrouped.length ? false : true}
                           updateCartStorage={props.updateCartStorage}
                        />
                     </div>
                  )
               })
            }
            </div>


            <div id="paideia-pre" className="p-5"></div>
            <div id="paideia" className="wn-series">
               <h2>New Books and Re-Publication of old Paideia Books of Piet Prins and other</h2>
               {paideia.length === 0 ?
                  <div className="wn-series-loading d-flex justify-content-center align-items-center">
                     <ReactLoading type="spin" color="#2D3142" />
                  </div> :
                  paideia.map((prod, i) => {
                     return (
                        <div key={prod.ipNumber}>
                           <NewProduct
                              product={prod}
                              isLast={i + 1 === paideia.length ? false : true}
                              updateCartStorage={props.updateCartStorage}
                           />
                        </div>
                     )
                  })
               }
            </div>

            <div id="yb-pre" className="p-5"></div>
            <div id="yb" className="wn-series">
               <h2>Young Burning Hearts Series</h2>
               {yb.length === 0 ?
                  <div className="wn-series-loading d-flex justify-content-center align-items-center">
                     <ReactLoading type="spin" color="#2D3142" />
                  </div> :
                  <div>
                     <div className="text-center p-4">
                        <img src={ybLogo} alt="Young Burning Hearts Series" />
                     </div>
                     {yb.map((prod, i) => {
                        return (
                           <div key={prod.ipNumber}>
                              <NewProduct
                                 product={prod}
                                 isLast={i + 1 === yb.length ? false : true}
                                 updateCartStorage={props.updateCartStorage}
                              />
                           </div>
                        )
                     })}
                  </div>
               }
            </div>
            <div id="wylie-pre" className="p-5"></div>
            <div id="wylie" className="wn-series">
               <h2>Wylie’s History of Protestantism</h2>
               {wylie.length === 0 ?
                  <div className="wn-series-loading d-flex justify-content-center align-items-center">
                     <ReactLoading type="spin" color="#2D3142" />
                  </div> :
                  wylie.map((prod, i) => {
                     return (
                        <div key={prod.ipNumber}>
                           <NewProduct
                              product={prod}
                              isLast={i + 1 === wylie.length ? false : true}
                              updateCartStorage={props.updateCartStorage}
                           />
                        </div>
                     )
                  })
               }
            </div>
         </div>
      </main>
   )
}

const mapStateToProps = state => {
   const books = state.books
   const products = state.whatsNew;
   return {
      books,
      products
   }
}

export default connect(mapStateToProps)(WhatsNew);
